<template>

<com-item name="players.specialised" :has-more="data.total > 5" v-on:more="onMoreClick" :size="size" :is-list="true" :loading="loading" :is-empty="!active" title="Game Specialists">

	<template v-slot:about>

		<p>Players with the most plays in a single game.</p>

	</template>

	<template v-slot:stats>

		<app-user type="player" :item="item" v-for="(item, index) in data.specialised" :override-name="$store.getters['data/games/associated'][item.game].name" :key="index" count-text="play" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

		loading: function() {

			return this.fetching === 'all' 

		},

		data: function() {

			return this.$store.getters['page/insights/players/specialised']

		},

		active: function() {

			return this.data.specialised.length && !this.loading

		}

	},

	methods: {

		onMoreClick: function() {
		
			this.$pubsub.$emit('panel.open', {
				type: 'insightsPlayersSpecialised'
			})
		
		}

	}

}

</script>

<style scoped>

</style>